import { setupPerformance } from './src/setup';

setupPerformance(window, document, {
  loadReport: false, // 是否加载 report.js
});
